import * as Yup from "yup";

const form = {
  formId: "change-password-form",
  formField: {
    currentPassword: {
      name: "currentPassword",
      label: "Current Password",
      type: "password",
      errorMsg: "Current Password is required.",
      invalidMsg: "The current password is incorrect.",
    },
    newPassword: {
      name: "newPassword",
      label: "New Password",
      type: "password",
      errorMsg: "New Password is required.",
      invalidMsg: "Your password is not strong enough.",
    },
    repeatNewPassword: {
      name: "repeatNewPassword",
      label: "Repeat New Password",
      type: "password",
      errorMsg: "Please repeat your new password.",
      invalidMsg: "Your password doesn't match.",
    },
  },
};

const {
  formField: { currentPassword, newPassword, repeatNewPassword },
} = form;

const initialValues = {
  [currentPassword.name]: "",
  [newPassword.name]: "",
  [repeatNewPassword.name]: "",
};

const validations = Yup.object().shape({
  [currentPassword.name]: Yup.string().required(currentPassword.errorMsg),
  [newPassword.name]: Yup.string().required(newPassword.errorMsg).min(6, newPassword.invalidMsg),
  [repeatNewPassword.name]: Yup.string()
    .required(repeatNewPassword.errorMsg)
    .oneOf([Yup.ref("newPassword"), null], repeatNewPassword.invalidMsg),
});

export { form, initialValues, validations };
